export function SparkleShineIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99373 11.453L7.65831 6.42536H9.81138L11.476 11.453L16.4697 13.1288V15.2965L11.476 16.9724L9.81138 22H7.65831L5.99373 16.9724L1 15.2965V13.1288L5.99373 11.453ZM8.73485 10.3994L7.96738 12.7174L7.24969 13.44L4.9473 14.2127L7.24969 14.9853L7.96738 15.7079L8.73485 18.0259L9.50231 15.7079L10.22 14.9853L12.5224 14.2127L10.22 13.44L9.50231 12.7174L8.73485 10.3994Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2818 4.67383L17.1671 2H18.4589L19.3442 4.67383L22 5.5651V6.86571L19.3442 7.75698L18.4589 10.4308H17.1671L16.2818 7.75698L13.626 6.86571V5.5651L16.2818 4.67383Z"
        fill="currentColor"
      />
    </svg>
  );
}
